import {
	Box,
	Container,
	createStyles,
	Flex,
	Group,
	Stack,
} from '@mantine/core';
import type { TeamOut } from '@repo/api-codegen';
import { Title } from '@repo/foundations';
import EmojiIconSelector from '../../../components/EmojiIconSelector';
import TeamMembersListButton from '../../../components/TeamMembersListButton';
import { HOMEPAGE_PADDING } from '../constants';
import { getBackgroundImageStyles } from '../utils';

interface IStyleParams {
	backgroundImage?: string;
}

interface ITeamsHomepageHeaderProps {
	team: TeamOut;
	image?: string;
	icon: string;
	onIconChange: (icon: string) => void;
}

const useStyles = createStyles((theme, { backgroundImage }: IStyleParams) => ({
	backgroundImage: getBackgroundImageStyles(theme, backgroundImage),
	emojiSelector: {
		paddingLeft: '0.5rem',
		marginTop: '-1rem',
	},
	title: {
		flexGrow: 1,
	},
	titleWrapper: {
		flexDirection: 'row',
		paddingTop: '1rem',
		alignItems: 'center',

		[theme.fn.smallerThan('xs')]: {
			flexDirection: 'column',
			alignItems: 'flex-start',
		},
	},
}));

function TeamsHomepageHeader({
	team,
	image,
	icon,
	onIconChange,
}: ITeamsHomepageHeaderProps) {
	const { classes } = useStyles({
		backgroundImage: image,
	});

	const title = `${team.name} Home`;

	return (
		<Stack spacing={0}>
			<Group
				position="right"
				align="start"
				className={classes.backgroundImage}
			/>
			<Container px={HOMEPAGE_PADDING} w="100%">
				<Box className={classes.emojiSelector}>
					<EmojiIconSelector
						key={icon}
						icon={icon}
						iconProps={{ size: 64 }}
						title="Home page icon"
						onChange={onIconChange}
						emojiSize={64}
					/>
				</Box>
				<Flex
					wrap="nowrap"
					justify="space-between"
					className={classes.titleWrapper}
				>
					<Title order={1} className={classes.title} lineClamp={1}>
						{title}
					</Title>
					<TeamMembersListButton size="md" spacing="md" team={team} />
				</Flex>
			</Container>
		</Stack>
	);
}

export default TeamsHomepageHeader;
